import { Grid, Button ,Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Autocomplete, TextField } from '@mui/material'
import React, { Fragment, memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useStyle } from '../style'
import axios from 'axios'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import _ from 'lodash'
import { Helmet } from 'react-helmet-async'
import dayjs from 'dayjs'
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from 'moment'
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import * as XLSX from 'xlsx';
const OutletGstReport = () => {
    const dispatch = useDispatch()
    const classes = useStyle()
    const outletName = localStorage.getItem('outlet_name')
    const outletId = localStorage.getItem('outlet_id')
    const fixedOutlet = { id: outletId, fullname: outletName };
    const [supplier, setSupplier] = useState([]);
    const roleId = localStorage.getItem("role_id")
    const[cust, setCust] = useState(null)
    const [data,setData] = useState([])
    const [dateLimit, setDateLimit] = useState({
      fromDate : moment().subtract(1, 'months').format(),
      toDate : moment().format()
    })
    function handleChange(e, name) {
      setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
    }

    function getGstLedger (){
      const postData = {
        from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
        to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
      }
        axios.post(`/v1/reports/outlet_sales/gst/gstledger/${cust!==null ? cust.id : fixedOutlet.id}`,postData)
        .then(res=>{
            
            setData(res.data.outlet_sales)
//             const combinedData = [];
// console.log(response)
// // Combine purchase and sales data
// response!==null && response.purchase.forEach(purchaseItem => {
//   const combinedItem = { ...purchaseItem, total : purchaseItem.amount + purchaseItem.cess_amt + purchaseItem.gst_amt + purchaseItem.igst_amt };
//   const salesItem = response.outlet_sales.find(salesItem => salesItem.gst_per === purchaseItem.gst_per);
//   if (salesItem) {
//     // combinedData.total = purchaseItem.amount + purchaseItem.cess_amt + purchaseItem.gst_amt + purchaseItem.igst_amt;
//     combinedItem.gst_sales = salesItem.gst_per;
//     combinedItem.sales_amount = salesItem.amount;
//     combinedItem.sales_cess_amt = salesItem.cess_amt;
//     combinedItem.sales_gst_amt = salesItem.gst_amt;
//     combinedItem.sales_igst_amt = salesItem.igst_amt;
//     combinedItem.sales_total = salesItem.amount + salesItem.cess_amt + salesItem.gst_amt + salesItem.igst_amt;

//   } else {
//     combinedItem.gst_sales = "";
//     combinedItem.sales_amount = "";
//     combinedItem.sales_cess_amt = "";
//     combinedItem.sales_gst_amt = "";
//     combinedItem.sales_igst_amt = "";
//     combinedItem.sales_total =""
//   }
//   combinedData.push(combinedItem);
// });

// // Add sales items not present in purchase
// response!==null && response.outlet_sales.forEach(salesItem => {
//   const exists = combinedData.some(combinedItem => combinedItem.gst_per === salesItem.gst_per);
//   if (!exists) {
//     combinedData.push({
//       gst_per: "",
//       amount: "",
//       total:'',
//       gst_sales: salesItem.gst_per,
//       sales_amount: salesItem.amount,
//       sales_cess_amt : salesItem.cess_amt,
//       sales_gst_amt : salesItem.gst_amt,
//       sales_igst_amt : salesItem.igst_amt,
//       sales_total : salesItem.amount + salesItem.cess_amt + salesItem.gst_amt + salesItem.igst_amt
//     });
//   }
// });

// console.log(combinedData);
// setData(combinedData)
        })
        .catch(err=>{
            console.log(err)
            dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
        })
    }

    function exportToExcel() {
      const wb = XLSX.utils.book_new();
      const wsData = data.map(item => [
        item.gst_per==='' ? item.gst_sales : item.gst_per,
        // item.amount,
        // item.amount === '' ? '' : item.amount / 2,
        // item.amount === '' ? '' : item.amount / 2,
        // item.igst_amt,
        // item.cess_amt,
        // item.total === "" ? "" : parseFloat(item.total).toFixed(2),
        item.sales_amount,
        item.gst_sales === '' ? "" : item.gst_sales / 2,
        item.gst_sales === '' ? "" : item.gst_sales / 2,
        item.sales_igst_amt,
        item.sales_cess_amt,
        item.sales_total === "" ? "" : parseFloat(item.sales_total).toFixed(2)
      ]);
    
      const ws = XLSX.utils.aoa_to_sheet([
        [
          // 'Purchase', 
          // '',
          // '',
          // '',
          // '',
          // '',
          // '',
          'Sales', 
          '',
          '',

        ],
        [
          'GST %',
          // 'Cash',
          // 'SGST',
          // 'CGST',
          // 'IGST',
          // 'CESS',
          // 'Total',
          'Cash',
          'SGST',
          'CGST',
          'IGST',
          'CESS',
          'Total'
        ],
        ...wsData
      ]);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "Outlet gst Report.xlsx");
    }
    function getSupplierData() {
      axios
        .get("/v1/outlet/list/1")
        .then((res) => {
          setSupplier(res.data);
          _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
        })
        .catch((err) => {
          dispatch(setSnackbar(true, "error", err.response.data.error));
        });
    }
    useEffect(()=>{
        getGstLedger()
    },[dateLimit,cust])
    useEffect(() => {
      getSupplierData();
    }, []);
  return (
<Fragment>
    <Helmet><title>Outlet Gst Report</title></Helmet>
    <Typography variant='h6'>Outlet GST Report</Typography>
    <Grid container spacing={2} className="p-2 pt-2">
    <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname}
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <Grid className='text-end my-2'>
    <Button onClick={exportToExcel} variant="outlined" > Export to Excel <SimCardDownloadOutlinedIcon /></Button>
      </Grid>
    <Grid className='flex'>
        <TableContainer className={classes.tblRoot}>
            <Table>
                <TableHead className={classes.tblHeader}>
                    <TableRow className={classes.tablrow}>
                        <TableCell sx={{borderLeft:`1px solid #ccc`}} className={classes.tblContentCell} colSpan={9} align='center'>Sales</TableCell>
                    </TableRow>
                    <TableRow className={classes.tablrow}>
                        <TableCell  sx={{borderLeft:`1px solid #ccc`}}>GST %</TableCell>
                        <TableCell >Cash</TableCell>
                        <TableCell>SGST</TableCell>
                        <TableCell>CGST</TableCell>
                        <TableCell>IGST</TableCell>
                        <TableCell>CESS</TableCell>
                        <TableCell>Total Gst</TableCell>
                        <TableCell>Total Qty</TableCell>
                        <TableCell>Total Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                          {data.length > 0 && _.map(data,(val, idx)=>(    
                     <TableRow className={classes.tablrow1} key={idx}>
                            <TableCell sx={{borderLeft: `1px solid #ccc`,textAlign:"center !important"}}>{val.gst_per==='' ? val.gst_sales : val.gst_per}</TableCell>
                            <TableCell>{parseFloat(val.amount).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.gst_amt / 2).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.gst_amt / 2).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.igst_amt).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.cess_amt).toFixed(0)}</TableCell>
                            <TableCell>{parseFloat(val.gst_amt).toFixed(0)}</TableCell>
                            <TableCell>{val.qty}</TableCell>
                            <TableCell sx={{textAlign:"right !important" , fontWeight:600}}>{parseFloat(val.amount + val.gst_amt + val.igst_amt +val.cess_amt).toFixed(0)}</TableCell>
                     </TableRow>
                        ))}
                </TableBody>
            </Table>
    
        </TableContainer>
    </Grid>
</Fragment>
  )
}

export default memo(OutletGstReport)